import { render, staticRenderFns } from "./ChatComitente.vue?vue&type=template&id=4e6cd4e6&scoped=true&"
import script from "./ChatComitente.vue?vue&type=script&lang=js&"
export * from "./ChatComitente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6cd4e6",
  null
  
)

export default component.exports